var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"niste-clan"},[_c('div',[_vm._v(_vm._s(_vm.$t('no_permission.message')))]),_c('a',{on:{"click":function($event){return _vm.sendTwoBack()}}},[_vm._v(_vm._s(_vm.$t('no_permission.return_button')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }